import { render, staticRenderFns } from "./iconUp.vue?vue&type=template&id=5eb76cc3&scoped=true&"
import script from "./iconUp.vue?vue&type=script&lang=js&"
export * from "./iconUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb76cc3",
  null
  
)

export default component.exports